import { FormBlockerElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'

import { getCheckboxElementKey } from '../ui/FormBlocker/elements/CheckboxElement/CheckboxElement'

export function getRequiredCheckboxElementKeys(elements: FormBlockerElement[]) {
  const requiredCheckbox =
    elements
      ?.map((element, formSectionIndex) => ({ element, formSectionIndex }))
      ?.filter(({ element }) => element['checkbox_element']?.is_required) ?? []

  return requiredCheckbox.map(({ formSectionIndex }) => {
    return getCheckboxElementKey(formSectionIndex)
  })
}
